import $ from 'jquery';

$(document).ready(() => {

	const selectors = {
		header: 'header.header',
	};

	const classes = {
		'scrolled': 'header--scrolled',
	};

	const threshold = 90;

	$(window).scroll((event) => {
		$(selectors.header).toggleClass(classes.scrolled, $(window).scrollTop() > threshold);
	});

});

